import { useContext } from "react";

import { OrganizationContext } from "@hooks/useOrganizationContext/OrganizationContext";

export const useOrganizationContext = () => useContext(OrganizationContext);
